var React = require('react');

function Github (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.493 10.242c0 4.324 2.748 7.992 6.56 9.287.48.09.654-.212.654-.472 0-.232-.008-.848-.013-1.664-2.668.59-3.23-1.313-3.23-1.313-.437-1.13-1.066-1.431-1.066-1.431-.87-.608.066-.595.066-.595.963.069 1.47 1.009 1.47 1.009.855 1.495 2.244 1.063 2.79.813.088-.633.336-1.064.61-1.309-2.13-.247-4.37-1.086-4.37-4.837 0-1.069.375-1.942.988-2.627-.098-.247-.427-1.242.094-2.59 0 0 .806-.263 2.638 1.004a9.018 9.018 0 0 1 2.4-.33 9.032 9.032 0 0 1 2.403.33c1.83-1.267 2.635-1.003 2.635-1.003.522 1.347.193 2.342.095 2.59.615.684.986 1.557.986 2.626 0 3.76-2.243 4.587-4.38 4.83.345.302.651.9.651 1.812 0 1.309-.011 2.364-.011 2.685 0 .262.173.566.66.47 3.807-1.296 6.553-4.962 6.553-9.285 0-5.406-4.295-9.787-9.592-9.787C4.788.455.493 4.836.493 10.242z"}));
}

Github.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 20 20"};

module.exports = Github;

Github.default = Github;
